import appConfig from './appConfig.js';

const STANDARD_REGEX = /%\{([^%]*)\}/g;
const FUNCTION_WITH_ARG_REGEX = /%\{(\w+) "(\S+)"\}/;

/*
 * interpolate() handles nested interpolation.
 * This method currently can handle single nested-interpolation %{interpolateLanguage "params"}.
 * This method checks whether the interpolation should be the result of a given function with one argument.
 * If so, call that function with the argument and interpolate the result in the string.
 * TODO: We should check if handlebars can handle nested-interpolation.
 */

const interpolate = function(string = '', options = {}, regex = STANDARD_REGEX) {
  let finalString = string;

  const isInterpolationFunction = FUNCTION_WITH_ARG_REGEX.test(finalString);
  const isEmptyOption = Object.keys(options).length === 0;
  const isEmptyString = finalString === null;

  if (isEmptyString) return '';

  if (isInterpolationFunction) {
    let [_, functionName, argument] = FUNCTION_WITH_ARG_REGEX.exec(finalString);
    let result = appConfig[functionName](argument);
    finalString = finalString.replace(FUNCTION_WITH_ARG_REGEX, result);
  }

  if (isEmptyOption) return finalString;

  return finalString.replace(regex, function(_, match) {
    return options[match] !== undefined ? options[match] : '';
  });
};

export default interpolate;
